(()=>{
  const REMOVED_SHELLS=new Set(['Techno Red','Remix Green','Rhythm Blue','Grey Camouflage']);

  const replaceExact=(el,from,to)=>{
    if(el&&el.textContent.trim()===from)el.textContent=to;
  };

  const apply=root=>{
    const status=root.querySelector('[data-axion-model-status]');
    if(status&&!status.classList.contains('is-ready')&&status.textContent.startsWith('3D LIVE ·'))status.textContent='Caricamento anteprima 3D…';
    const selected=root.querySelector('[data-action="shell"].is-selected');
    const black=root.querySelector('[data-action="shell"][data-value="Black"]');
    if(selected&&REMOVED_SHELLS.has(selected.dataset.value)&&black&&!black.disabled){
      black.click();
      return;
    }

    root.querySelectorAll('[data-action="shell"]').forEach(btn=>{
      if(REMOVED_SHELLS.has(btn.dataset.value)){
        btn.remove();
        return;
      }
      const included=btn.querySelector('small');
      if(included&&included.textContent.trim()==='INCLUSO')included.remove();
    });

    root.querySelectorAll('.axv3-card em,.axv3__review-row em,.axv3__shellbtn small').forEach(el=>{
      if(el.textContent.trim().toUpperCase()==='INCLUSO')el.textContent='';
    });

    root.querySelectorAll('[data-steps] span').forEach(el=>{
      replaceExact(el,'Input Smart','Smart Input');
      replaceExact(el,'Estetica','Personalizzazione');
      replaceExact(el,'Produzione','Realizzazione');
    });

    root.querySelectorAll('.axv3__stephead h2').forEach(el=>{
      replaceExact(el,'Input Smart.','Smart Input.');
      replaceExact(el,'Estetica.','Personalizzazione.');
      replaceExact(el,'Priorità produzione.','Realizzazione.');
    });

    root.querySelectorAll('.axv3__stephead p').forEach(el=>{
      replaceExact(el,'Scegli la finitura. L’anteprima utilizza gli stessi scatti del vecchio designer, ora nel motore Axion.','Scegli il colore della scocca e visualizza il risultato in tempo reale sul tuo controller.');
      replaceExact(el,'Personalizza ogni componente. Il colore viene composto in tempo reale sugli asset fotografici, senza generare una nuova immagine.','Personalizza ogni dettaglio del controller: scegli colori e finiture per creare una configurazione unica.');
    });

    root.querySelectorAll('.axv3__next').forEach(el=>{
      replaceExact(el,'INPUT SMART →','SMART INPUT →');
      replaceExact(el,'ESTETICA →','PERSONALIZZAZIONE →');
      replaceExact(el,'PRODUZIONE →','REALIZZAZIONE →');
    });

    root.querySelectorAll('.axv3__review-row span,.axv3__devcart-spec span').forEach(el=>{
      replaceExact(el,'Estetica','Personalizzazione');
      replaceExact(el,'Produzione','Realizzazione');
    });

    root.querySelectorAll('.axv3__payload-head strong').forEach(el=>{
      if(el.textContent.includes('PRODUCTION PAYLOAD'))el.textContent=el.textContent.replace('PRODUCTION PAYLOAD','BUILD PAYLOAD');
    });
  };

  document.querySelectorAll('[data-axion-configurator]').forEach(root=>{
    if(root.dataset.axionV57==='1')return;
    root.dataset.axionV57='1';

    let queued=false;
    const run=()=>{queued=false;apply(root)};
    const schedule=()=>{
      if(queued)return;
      queued=true;
      queueMicrotask(run);
    };

    new MutationObserver(schedule).observe(root,{childList:true,subtree:true,characterData:true});
    run();
  });
})();

/* AXION Configurator DEV — desktop step scroll reset.
 * Reset only when the active configurator step changes. In-step option/color
 * renders keep the user's current scroll position. Mobile remains core-managed.
 */
(()=>{
  const ROOT_SELECTOR='[data-axion-configurator][data-product-handle="axion-designer-ps5"]';

  const activeStep=root=>{
    const el=root.querySelector('[data-steps] [data-action="step"].is-active');
    const value=Number(el?.dataset.step);
    return Number.isFinite(value)?value:-1;
  };

  const headerOffset=()=>{
    const sections=[...document.querySelectorAll('.shopify-section-group-header-group')]
      .filter(el=>el.getBoundingClientRect().height>0);

    if(sections.length){
      return Math.min(180,sections.reduce((sum,el)=>sum+el.getBoundingClientRect().height,0));
    }

    const header=document.querySelector('header-component');
    return Math.min(180,header?.getBoundingClientRect().height||0);
  };

  const scrollConfiguratorTop=root=>{
    if(window.innerWidth<851)return;

    requestAnimationFrame(()=>{
      requestAnimationFrame(()=>{
        const top=root.getBoundingClientRect().top+window.scrollY-headerOffset();
        window.scrollTo({top:Math.max(0,top),behavior:'auto'});
      });
    });
  };

  document.querySelectorAll(ROOT_SELECTOR).forEach(root=>{
    if(root.dataset.axionStepScrollResetBound==='1')return;

    const steps=root.querySelector('[data-steps]');
    if(!steps)return;

    root.dataset.axionStepScrollResetBound='1';
    root.addEventListener('click',event=>{
      const button=event.target.closest('[data-action="next"]');
      if(!button||window.innerWidth<851)return;
      event.preventDefault();
      event.stopImmediatePropagation();
      button.blur();
      const targetStep=activeStep(root)+1;
      const top=Math.max(0,root.getBoundingClientRect().top+window.scrollY-headerOffset());
      const started=performance.now();
      let finished=false;
      const finish=()=>{
        if(finished)return;
        finished=true;
        root.dataset.axionSkipNextScroll='1';
        steps.querySelector('[data-action="step"][data-step="'+targetStep+'"]')?.click();
      };
      const watch=()=>{
        if(Math.abs(window.scrollY-top)<=2||performance.now()-started>900)return finish();
        requestAnimationFrame(watch);
      };
      window.scrollTo({top,behavior:'smooth'});
      requestAnimationFrame(watch);
    },true);
    let currentStep=activeStep(root);
    let queued=false;

    const checkStep=()=>{
      queued=false;
      const nextStep=activeStep(root);
      if(nextStep<0||nextStep===currentStep)return;

      currentStep=nextStep;
      if(root.dataset.axionSkipNextScroll==='1'){
        delete root.dataset.axionSkipNextScroll;
        return;
      }
      scrollConfiguratorTop(root);
    };

    const observer=new MutationObserver(()=>{
      if(queued)return;
      queued=true;
      queueMicrotask(checkStep);
    });

    observer.observe(steps,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  });
})();


/* Navigation helpers reuse the existing preview and never move its camera. */
(()=>{
  document.querySelectorAll('[data-axion-configurator][data-product-handle="axion-designer-ps5"]').forEach(root=>{
    const steps=root.querySelector('[data-steps]'),bar=root.querySelector('.axv3__mobilebar');
    if(!steps||!bar)return;
    const progress=document.createElement('p');
    progress.className='axv3__step-progress';progress.setAttribute('aria-live','polite');
    steps.before(progress);
    const preview=document.createElement('button');preview.type='button';preview.textContent='VEDI 3D';
    preview.className='axv3__preview-jump';preview.addEventListener('click',()=>root.querySelector('.axv3__preview')?.scrollIntoView({behavior:'smooth',block:'start'}));
    bar.insertBefore(preview,bar.querySelector('[data-mobile-next]'));
    const back=document.createElement('button');back.type='button';back.className='axv3__preview-return';back.textContent='TORNA ALLE OPZIONI ↓';
    back.addEventListener('click',()=>root.querySelector('[data-workspace]')?.scrollIntoView({behavior:'smooth',block:'start'}));
    root.querySelector('.axv3__preview')?.append(back);
    const update=()=>{
      const active=steps.querySelector('.is-active'),index=Number(active?.dataset.step)||0;
      const label=active?.querySelector('span')?.textContent||'';
      const text='Passaggio '+(index+1)+' di 7 · '+label;
      if(progress.textContent!==text)progress.textContent=text;
      steps.querySelectorAll('button').forEach(button=>button.setAttribute('aria-current',button===active?'step':'false'));
      if(innerWidth<851&&active)steps.scrollLeft=Math.max(0,active.offsetLeft-steps.offsetLeft-(steps.clientWidth-active.offsetWidth)/2);
    };
    root.addEventListener('axion:configuration-changed',()=>queueMicrotask(update));update();
  });
})();

/* AXION Configurator DEV — stable workspace height (desktop).
 * Inside a step, the options panel never becomes shorter after a selection:
 * page height, 3D preview position and scroll position stay put instead of
 * jumping (e.g. choosing "No Bottoni" after "4 Bottoni").
 * The lock is released whenever the active step changes.
 * Mobile (<851px) remains core-managed.
 */
(()=>{
  document.querySelectorAll('[data-axion-configurator]').forEach(root=>{
    if(root.dataset.axionStableHeightBound==='1')return;
    const workspace=root.querySelector('[data-workspace]');
    if(!workspace)return;
    root.dataset.axionStableHeightBound='1';

    const activeStep=()=>{
      const el=root.querySelector('[data-steps] [data-action="step"].is-active');
      const value=Number(el?.dataset.step);
      return Number.isFinite(value)?value:-1;
    };

    const release=()=>{workspace.style.minHeight=''};

    const lock=()=>{
      if(window.innerWidth<851)return release();
      const cs=getComputedStyle(workspace);
      const extra=cs.boxSizing==='border-box'?0:
        (parseFloat(cs.paddingTop)||0)+(parseFloat(cs.paddingBottom)||0)+
        (parseFloat(cs.borderTopWidth)||0)+(parseFloat(cs.borderBottomWidth)||0);
      const height=workspace.getBoundingClientRect().height-extra;
      if(height>0)workspace.style.minHeight=height+'px';
    };

    root.addEventListener('click',e=>{
      const button=e.target.closest('button');
      if(!button||button.disabled)return;
      const action=button.dataset.action;
      if(action==='step'||action==='next'||action==='prev'||button.matches('[data-mobile-next]'))return release();
      lock();
    },true);

    root.addEventListener('change',lock,true);

    let lastStep=activeStep();
    root.addEventListener('axion:configuration-changed',()=>{
      const step=activeStep();
      if(step<0||step===lastStep)return;
      lastStep=step;
      release();
    });
  });
})();
